import request from "../../utils/NetWorkUtil";

export async function getPolicyConsult(params= {}) {
    return request('/api/PolicyConsult', {
        method: 'GET',
        params: {
            page: 1,
            size: 100,
            ...params
        }
    });
}

export async function getPolicyCate() {
    return request('/api/PolicyCate', {
        method: 'GET'
    });
}

